export class RegionCodeApiResponse {
	constructor(
		public nom: string,
		public code: string,
		public codeDepartement: string,
		public siren: string,
		public codeEpci: string,
		public codeRegion: string,
		public codesPostaux: string[],
		public population: number
	) {}
}

export class RegionApiResponse {
	constructor(
		public nom: string,
		public code: string,
	) {}
}
